export function createAsyncListenerWithCleanup(
  createListener: () => Promise<() => void>
): () => void {
  let cleanup: (() => void) | undefined;
  let cleaned = false;

  createListener().then((listener) => {
    if (cleaned) {
      listener();
    } else {
      cleanup = listener;
    }
  });

  return () => {
    if (cleanup) {
      cleanup();
    } else {
      cleaned = true;
    }
  };
}
